if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        document.body.classList.remove('overflow-hidden');
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        document.body.classList.add('overflow-hidden');
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
            'data-media-id',
          )}"])`,
        ).forEach(element => {
          element.classList.remove('active');
          element.classList.remove('swiper-slide-active');
        });
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`,
        );
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;
        activeMedia.classList.add('active');
        // activeMedia.classList.add('swiper-slide-active');

        let activeIndexMain = 0;
        const allSlides = document.querySelectorAll(
          '#ProductModalContent .swiper-slide',
        );
        const swiperRemote = document.querySelector('#ProductModalContent').swiper;
        swiperRemote.update();

        /*
        const widthScreen = window.innerWidth;
        if (widthScreen <= 1024) {
          activeMedia.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
        */

        /*
        activeMedia.scrollIntoView();        
        */

        allSlides.forEach((slide, index) => {
          if (slide.classList.contains('active')) {
            activeIndexMain = parseInt(index);
            return;
          }
        });
        const sliderwrapper = document.querySelector(
          '#ProductModalContent .swiper-wrapper',
        );
        sliderwrapper.dataset.active = activeIndexMain;
        swiperRemote.slideTo(activeIndexMain, 0, false);
        swiperRemote.update();
        swiperRemote.on('slideChange', function () {
          const activeIndex = swiperRemote.activeIndex;
          const sliderwrapper = document.querySelector(
            '#ProductModalContent .swiper-wrapper',
          );
          sliderwrapper.dataset.active = activeIndex;
          swiperRemote.updateSize();
        });

        // Calcula la nueva posición de desplazamiento *
        // const newScrollPosition = activeImage.offsetLeft - slider.offsetLeft;

        // Desplaza el slider *
        // slider.scrollLeft = newScrollPosition;

        /*
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        */

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    },
  );
}
